/**
 * PermissionShow directive
 * used with permissionResource to show/hide by style element depending on SAM Permissions
 *
 */


import {Directive, ElementRef, Input, Renderer2} from '@angular/core';
import {PermissionResourceService} from "../service/resources/permission/permissionResource.service";

@Directive({
    selector: '[permissionShow]'
})
export class PermissionShowDirective {
    @Input('permissionShow')
    public path: string;

    constructor(private el: ElementRef,
                private renderer: Renderer2,
                private permission: PermissionResourceService) {
    }


    public ngAfterViewInit() {
        //for debug, add path in classes
        this.renderer.addClass(this.el.nativeElement, this.path);

        this.permission.hasPermission(this.path)
            .subscribe((hasPermission) => {

                if (!hasPermission) {
                    this.renderer.setStyle(this.el.nativeElement, "display", "none");
                } else {
                    this.renderer.removeStyle(this.el.nativeElement, "display");
                }
            });

    }


}